/**
 * useIsMobileViewport — shared responsive breakpoint hook.
 * Reactively re-renders callers on viewport crossing 768px so
 * task-row click behaviour, dialog picker, etc. stay in sync
 * when the user rotates a tablet or resizes their window.
 */
import { useEffect, useState } from "react";

const MQ = "(max-width: 767.98px)";

export function useIsMobileViewport() {
  const [is, setIs] = useState(() =>
    typeof window !== "undefined" ? window.matchMedia(MQ).matches : false,
  );
  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const mq = window.matchMedia(MQ);
    const onChange = () => setIs(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return is;
}

export default useIsMobileViewport;
